export default __webpack_public_path__ + "static/media/javascriptDeepDive.0219a1ad.md";